import React, { useState } from 'react'
import { Modal } from 'asterX-UI/Modals'
import { Button, DialogActions, makeStyles } from '@material-ui/core'
import {
  BASE_COLORS,
  GRAY_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from 'asterX-UI'
import {
  AVAILABLE,
  AWAITS,
  KEY_STATUSES,
  ON_YOU,
  UNAVAILABLE
} from 'constants/keyStatuses'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import KeyIcon from 'asterX-UI/Icons/KeyIcon'
import QrForKey from './QrForKey'
import { useAuthStore } from 'context/AuthStore'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'
import HeaderBack from 'components/Desktop/HeaderBack'

const useStyles = makeStyles(() => ({
  rootDiv: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    position: 'relative',
    height: '75vh',
    overflowY: 'auto',
    marginTop: 20
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    borderRadius: 10,
    backgroundColor: BASE_COLORS.White,
    gap: 12
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },
  carName: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
    color: GRAY_COLORS[700]
  },
  carVin: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
    color: GRAY_COLORS[700]
  },
  carBranch: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
    color: GRAY_COLORS[500]
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
}))
const GetKeysModal = ({
  open,
  onClose,
  keysData = [],
  loading,
  refreshKeys = () => {},
  acceptKey = () => {}
}) => {
  const classes = useStyles()
  return (
    <Modal fullWidth maxWidth={'md'} open={open} onClose={onClose}>
      <PageContainerDesktop
        disablePaddings
        customHeader={<HeaderBack onClick={onClose}>Получить ключи</HeaderBack>}
      >
        <LoaderBackdrop loading={loading} />
        <div className={classes.rootDiv}>
          {keysData.map((v, index) => (
            <Card
              key={index + '_key'}
              keyData={v}
              refreshKeys={refreshKeys}
              acceptKey={acceptKey}
            />
          ))}
        </div>
      </PageContainerDesktop>
      <DialogActions>
        <Button variant={'contained'} fullWidth onClick={refreshKeys}>
          Обновить ключи
        </Button>
      </DialogActions>
    </Modal>
  )
}
export default GetKeysModal

const Card = ({ keyData, refreshKeys, acceptKey }) => {
  const classes = useStyles()
  const [openQr, setOpenQr] = useState(false)
  const {
    store: { sale }
  } = useSelectionStore()
  const {
    authStore: { user }
  } = useAuthStore()
  return (
    <div className={classes.card}>
      <div className={classes.cardContent}>
        <div className={classes.row}>
          <div className={classes.carName}>{`${keyData?.marka || ''} ${
            keyData?.model || ''
          } ${keyData?.year || ''}`}</div>
          {[ON_YOU, AWAITS].includes(keyData.status) && (
            <ChipStandard
              {...(keyData.status === ON_YOU
                ? {
                    color: SUCCESS_COLORS[700],
                    backgroundColor: SUCCESS_COLORS[50]
                  }
                : {
                    color: WARNING_COLORS[700],
                    backgroundColor: WARNING_COLORS[50]
                  })}
            >
              <KeyIcon
                style={{
                  fontSize: 14
                }}
              />
              {KEY_STATUSES?.[keyData.status] || '-'}
            </ChipStandard>
          )}
        </div>
        <div className={classes.carVin}>{keyData?.vin || '-'}</div>
        <div className={classes.carBranch}>{keyData?.branch || '-'}</div>
        <div className={classes.carBranch}>
          {(!!keyData?.stockPlace?.rowNo
            ? `Ряд ${keyData?.stockPlace?.rowNo}, `
            : '') +
            (!!keyData?.stockPlace?.placeNo
              ? `Место ${keyData?.stockPlace?.placeNo}, `
              : '') +
            (!!keyData ? `Номер ключа ${keyData?.keyNumber}` : '')}
        </div>
      </div>
      {[UNAVAILABLE, AWAITS, AVAILABLE]?.includes(keyData.status) && (
        <div className={classes.row}>
          {keyData.status === UNAVAILABLE && (
            <Button fullWidth variant={'text'} color={'secondary'}>
              {KEY_STATUSES?.[UNAVAILABLE]}
            </Button>
          )}
          {keyData.status === AWAITS && (
            <Button
              fullWidth
              variant={'contained'}
              color={'primary'}
              onClick={() => acceptKey(keyData?.id, sale?.id)}
            >
              Принять ключ
            </Button>
          )}
          {keyData.status === AVAILABLE && (
            <Button
              fullWidth
              variant={'contained'}
              onClick={() => setOpenQr(true)}
            >
              Получить ключ
            </Button>
          )}
        </div>
      )}
      {openQr && (
        <QrForKey
          open={openQr}
          onClose={() => {
            refreshKeys()
            setOpenQr(false)
          }}
          data={{
            keyNumber: keyData.keyNumber,
            attachTo: user?.data?.username
          }}
        />
      )}
    </div>
  )
  /*     data={{
            keyNumber: updatedCar.keyNumber,
            attachTo: currentUser.username
          }}*/
}
